<template>
    <div class="">
        <div class="node_c_left">
            <!--            <div class="node_title">
                <el-select v-model="selectedLang" @change="getCategory">
                    <el-option v-for="lang in languages" :key="`lang${lang.c_idx}`" :value="lang.c_idx"
                               :label="lang.c_lang_ko"></el-option>
                </el-select>
            </div>-->
            <div class="node_btn_wrap">
                <el-row>
                    <el-col :span="12" class="text_left">
                        <el-button size="mini" @click="open(true)">전부열기</el-button>
                        <el-button size="mini" @click="open(false)">전부닫기</el-button>
                    </el-col>
                    <el-col :span="12" class="text_right">
                        <!--                        <el-button size="mini" type="primary" @click="addNode()" class="node_add_btn">카테고리1 추가</el-button>-->
                    </el-col>
                </el-row>
            </div>
            <div class="node has_warn">
                <div class="node_wrap" v-if="cateArr.length > 0">
                    <vue-tree-list v-show="cateArr.length > 0" @click="onClick" @delete-node="onDel" @add-node="onAddNode"
                        :model="cateData" default-tree-node-name="새로운 카테고리" default-leaf-node-name="새로운 카테고리"
                        :default-expanded="nodeOpen">
                        <span class="icon add" slot="addTreeNodeIcon">
                            <img src="@/assets/image/common/black_plus.png" alt="">
                        </span>
                        <span class="icon" slot="addLeafNodeIcon"></span>
                        <span class="icon" slot="editNodeIcon"></span>
                        <template v-slot:delNodeIcon="slotProps">
                            <span class="icon del" v-if="slotProps.model.cci_chk_delete != 1">
                                <img src="@/assets/image/common/trash.png" alt="">
                            </span>
                        </template>

                        <span class="icon" slot="leafNodeIcon"></span>
                        <span class="icon" slot="treeNodeIcon"></span>
                    </vue-tree-list>
                    <pre></pre>
                </div>
            </div>
        </div>
        <div class="node_c_right">
            <div class="node_title">분류 정보</div>

            <div class="c_table_wrap node_input">
                <table>
                    <colgroup>
                        <col width="150px;">
                        <col>
                    </colgroup>
                    <tbody>
                        <tr>
                            <td class="c_t_title">카테고리 이름</td>
                            <td>
                                <el-input v-model="nodeName" placeholder="카테고리의 이름을 입력해주세요." maxLength="20"
                                    :disabled="checkHas1Depth()">
                                </el-input>
                            </td>
                        </tr>
                        <tr v-if="!checkHas1Depth()">
                            <td class="c_t_title">카테고리 순서</td>
                            <td>
                                <div>
                                    <el-input v-model="nodeSequence" placeholder="카테고리의 순서를 입력해주세요."
                                        @input="setInteger('nodeSequence', nodeSequence)" type="number"></el-input>
                                </div>
                                <div class="input_error" v-if="!checkSequenceValue() && this.nodeSequence != ''">순서 값은 0이상의
                                    숫자만 입력해주세요.
                                </div>
                            </td>
                        </tr>
                        <tr v-if="!checkHas1Depth() && checkHasLevel()">
                            <td class="c_t_title">레벨</td>
                            <td>
                                <div>
                                    <el-input v-model="nodeLevel" placeholder="카테고리의 레벨을 입력해주세요."
                                        @input="setInteger('nodeLevel', nodeLevel)"></el-input>

                                </div>
                            </td>
                        </tr>
                        <tr v-if="!checkHas1Depth()">
                            <td class="c_t_title">카테고리 사진</td>
                            <td>
                                <div class="file_upload" @click="changeType('files')">
                                    <div class="fs15 pb10">리스트 이미지</div>
                                    <el-upload 
                                        action="" 
                                        class="avatar-uploader main" 
                                        :auto-upload="false"
                                        list-type="picture-card" 
                                        :show-file-list="false" 
                                        :file-list="files"
                                        :on-change="onlyOnePhotoChange"
                                        >
                                        <img v-if="hasImage(files)" :src="files[0].url">
                                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                        <div slot="tip" class="el-upload__tip c_danger">264 x 390사이즈에 최적화되어있습니다.</div>
                                        <div slot="tip" class="el-upload__tip c_danger">jpg/png 종류의 파일과 10MB 이하의 파일만
                                            가능합니다.
                                        </div>
                                    </el-upload>
                                </div>

                                <div class="file_upload" v-if="!checkHas1Depth()" @click="changeType('fileDetail')">
                                    <div class="fs15 pb10">상세 이미지</div>
                                    <el-upload action="" class="avatar-uploader" :auto-upload="false"
                                        list-type="picture-card" :show-file-list="false" :file-list="fileDetail"
                                        :on-change="onlyOnePhotoChange">
                                        <img v-if="hasImage(fileDetail)" :src="fileDetail[0].url">
                                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                        <div slot="tip" class="el-upload__tip c_danger">140 x 140사이즈에 최적화되어있습니다.</div>
                                        <div slot="tip" class="el-upload__tip c_danger">jpg/png 종류의 파일과 10MB 이하의 파일만
                                            가능합니다.
                                        </div>
                                    </el-upload>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="text_center n_btn_wrap" v-show="!checkHas1Depth()">
                    <el-button class="n_i_btn" type="primary" :disabled="checkBtnUpdate()" @click="updateNode">수정
                    </el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import util from "@/mixins/util";
import elFileMixins from "@/mixins/elFileMixins";
import { appLanguage } from "@/service/languageService";
import { VueTreeList, Tree, TreeNode } from 'vue-tree-list'
import areaMixins from "@/mixins/areaMixins";
import imageOption from "@/mixins/imageOption";
import DeleteClass from "@/mixins/deleteClass";
import {noLevelNodeId} from "@/service/contentService";
import ssamTalkUtil from "./ssamtalkUtil";

export default {
    name: "SsamTalkCategoryComponent",
    mixins: [elFileMixins, areaMixins, imageOption,ssamTalkUtil],
    components: {
        VueTreeList
    },
    inject: [],
    provide() {
        return {}
    },
    props: {
        categoryType : '',
    },
    data() {
        return {
            imageMaxSize: 1024 * 1024 * 10,
            languages: appLanguage,
            selectedLang: '',
            cateData: [],
            cateArr: [],
            nodeName: '',
            nodeWrap: null,
            nodeFile: null,
            nodeLevel: '',
            nodeOpen: true,
            DeleteClass: null,

            nodeSequence: '',

            fileDetail: [],
            categoryApiParamsSet : {},
            getFunc : '',
            updateFunc : '',
            createFunc : '',
            deleteFailTypes : {},
            keyName : '',
            ctType: ''
        }
    },
    beforeRouterEnter() {
    },
    created() {
        // this.cateData = new Tree(this.cateArr)
        // this.selectedLang = this.languages[0].c_idx;
        this.selectedLang = 30;
        this.initConfig();
        this.initData();
        this.newDeleteClass();
        this.getCategory();
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        newDeleteClass() {
            let deleteOptions = {
                func: this.$api.$ssamtalk.deleteSsamTalkCategory,
                apiParamSet: {},
                keyName: this.keyName,
                successType: 1,
                errorTypes:this.deleteFailTypes,
                afterFunc: this.deleteAfterFunc,
            }
            this.DeleteClass = new DeleteClass(deleteOptions);
        },
        initConfig() {
            let config = this.returnSsamTalkConfig(this.categoryType); 
            this.categoryApiParamsSet = config.categoryApiParamsSet;
            this.getFunc = config.getFunc;
            this.writeFunc = config.writeFunc;
            this.createFunc = config.createFunc;
            this.deleteFailTypes = config.deleteFailTypes;
            this.keyName = config.keyName;
            this.ctType = config.ctType;
        },
        initData() {
            this.cateData = new Tree(this.cateArr)
            this.cateArr = [];
            this.nodeName = '';
            this.nodeWrap = null;
            this.nodeLevel = '';
            this.files = [];
            this.fileDetail = [];
            this.nodeSequence = ''
            $('.vtl-node').removeClass('active');
        },
        open(type) {
            this.nodeOpen = '';
            // this.getDetail();
            this.$nextTick(() => {
                this.nodeOpen = type;
                this.getCategory();
            })
        },
        getCategory() {
            let params = this.categoryApiParamsSet;
            this.cateData = new Tree(this.cateArr)
            this.cateArr = [];
            this.$api.$ssamtalk[this.getFunc](params).then(res => res.Data.Result).then(res => {
                this.cateArr = this.makeTreeArr(res.List);
                this.cateData = new Tree(this.cateArr)
                // this.cateArr = res.List;
            })
        },
        makeTreeArr(node, array) {
            util.Array.each(node, (depth1, depth1Index, node) => {
                depth1.dragDisabled = true;
                depth1.id = depth1.node_id;
                depth1.name = depth1.sc_name;
                depth1.pid = 0;
                if (!util.isEmpty(depth1.children)) {
                    util.Array.each(depth1.children, (depth2, depth2Index, children) => {
                        depth2.dragDisabled = true;
                        depth2.id = depth2.node_id;
                        depth2.pid = depth2.parent_id;
                        depth2.isLeaf = true;
                        delete depth2.children;
                    })
                } else {
                    delete depth1.children;
                }
            })
            return node;
        },
        onDel(node) {
            let confirmText = '삭제시 해당 카테고리와 카테고리내 콘텐츠들이 모두 삭제됩니다.<br>정말 삭제하시겠습니까?';
            if (util.isEmpty(node.parent_id)) {
                confirmText = '삭제시 해당 카테고리와 하위 카테고리 모두 삭제됩니다.<br>정말 삭제하시겠습니까?';
            }
            this.createConfirm({
                content: confirmText,
                confirm: () => {
                    this.cateDel(node);
                }
            })
        },
        cateDel(node) {
            this.DeleteClass.runDelete(node.node_id);
        },
        deleteAfterFunc() {
            this.nodeName = '';
            this.nodeWrap = null;
            this.nodeLevel = '';
            this.files = [];
            this.fileDetail = [];
            this.getCategory();
        },
        updateNode() {
            let params = {
                node_id: this.nodeWrap.node_id,
                name: this.nodeName,
                cci_level: this.nodeLevel,
                cci_seq: this.nodeSequence,
                parent_id: this.nodeWrap.parent_id,
            }
            /*if(this.nodeName === this.nodeWrap.name) {
                delete params.name;
            }*/
            if (this.nodeLevel === this.nodeWrap.cci_level) {
                delete params.cci_level;
            }
            if (this.nodeSequence === this.nodeWrap.cci_seq) {
                delete params.cci_seq;
            }
            if (this.checkChangedData(params)) {
                this.uploadFiles(this.files, 'c-category', this.nodeWrap.node_id).then(success => {
                    this.uploadFiles(this.fileDetail, 'c-category-fit', this.nodeWrap.node_id).then(success => {
                        this.updateAfterFunc(params.node_id);
                    });
                });
                return false;
            }
            try {
                this.$api.$ssamtalk[this.writeFunc](params).then(res => res.Data.Result).then(res => {
                    let type = this.returnUpdateType(res.Info.type);
                    if (type === true) {
                        /*if(!util.isEmpty(this.files) && this.files.filter(file => file.hasOwnProperty('raw')).length > 0) {
                            this.uploadFiles(this.files, this.fileType, this.nodeWrap.node_id).then(success => {
                                this.updateAfterFunc(res.List);
                            });
                        }else{
                            this.updateAfterFunc();
                        }*/
                        this.uploadFiles(this.files, 'c-category', this.nodeWrap.node_id).then(success => {
                            this.uploadFiles(this.fileDetail, 'c-category-fit', this.nodeWrap.node_id).then(success => {
                                this.updateAfterFunc(res.List);
                            });

                        });
                    } else {
                        this.errorAlert(type);
                    }
                })
            } catch (e) {
                console.log(e);
            }
        },
        checkChangedData(params) {
            //데이터가 변하지 않으면 이미지 파일만 업데이트
            return this.nodeWrap.name === this.nodeName && !params.hasOwnProperty('cci_level') && !params.hasOwnProperty('cci_seq')
        },
        updateAfterFunc() {
            this.createAlert({
                content: '저장되었습니다.',
                hide: () => {
                    this.initData();
                    this.getCategory();
                }
            })
        },
        returnUpdateType(type) {
            switch (type) {
                case 1:
                    return true;
                case -5:
                    return '해당 카테고리를 찾을 수가 없습니다.';
                case -200:
                    return '카테고리명이 중복됩니다.';
                case -203:
                    return '타입이 올바르지 않습니다.';
                case -300:
                    return '해당 레벨이 존재합니다.';
                case -403:
                    return '권한이 없습니다.';
                default:
                    return "카테고리 수정에 실패하였습니다."
            }
        },
        onAddNode(node) {
            this.addNode(node.pid);
        },

        onClick(params) {
            this.nodeWrap = params;
            this.nodeName = this.nodeWrap.name;
            this.nodeLevel = this.nodeWrap.cci_level;
            this.nodeSequence = this.nodeWrap.cci_seq
            $('.vtl-node').removeClass('active');
            $(`.vtl-node#${params.id}`).addClass('active');
            if (!util.isEmpty(this.nodeWrap.File)) {
                let fileWrap = this.nodeWrap.File[0];
                fileWrap.url = `${fileWrap.org_url}?${this.setImageOptions(264, 390, 'webp')}`;
                fileWrap.name = fileWrap.org_name;
                if (util.isEmpty(fileWrap.a_idx)) {
                    delete fileWrap.a_idx;
                }
                this.files = [fileWrap];
            } else {
                this.nodeFile = null;
            }

            if (!util.isEmpty(this.nodeWrap.FitFile)) {
                let fileWrap = this.nodeWrap.FitFile[0];
                fileWrap.url = `${fileWrap.org_url}?${this.setImageOptions(140, 140, 'webp')}`;
                fileWrap.name = fileWrap.org_name;
                if (util.isEmpty(fileWrap.a_idx)) {
                    delete fileWrap.a_idx;
                }
                this.fileDetail = [fileWrap];
            }
        },

        addNode(parent = null) {
            let params = {
                name: '새로운 카테고리',
                parent_id: parent,
                c_idx: this.selectedLang,
                cc_type: this.ctType,
            }
            if (util.isEmpty(params.parent_id)) {
                delete params.parent_id;
            }
            this.$api.$ssamtalk[this.createFunc](params).then(res => res.Data.Result).then(res => {
                let type = this.returnCreateType(res.Info.type);
                if (type === true) {
                    this.getCategory();
                } else {
                    this.errorAlert(type);
                    this.getCategory();
                }
            })
        },
        returnCreateType(type) {
            switch (type) {
                case 1:
                    return true;
                case -200:
                    return '카테고리명이 중복됩니다';
                case -403:
                    return '권한이 없습니다.';
                default:
                    return "카테고리 생성에 실패하였습니다."
            }
        },
        hasImage(file) {
            return !util.isEmpty(file);
        },
        setInteger(key, value) {
            this[key] = isNaN(value) ? value : Number(value);
        },
        checkHas1Depth() {
            return !util.isEmpty(this.nodeWrap) && util.isEmpty(this.nodeWrap.parent_id)
        },
        checkHasLevel() {
            if (util.isEmpty(this.nodeWrap)) {
                return false;
            }
            return noLevelNodeId[1].indexOf(this.nodeWrap.node_id) < 0 && noLevelNodeId[1].indexOf(this.nodeWrap.parent_id) < 0 && noLevelNodeId[2].indexOf(this.nodeWrap.node_id) < 0;
        },
        checkLevelValue() {
            return this.checkHas1Depth() || !this.checkHasLevel() || (util.Number.isInteger(this.nodeLevel) && this.nodeLevel >= 0)
        },
        checkSequenceValue() {
            return this.checkHas1Depth() || (util.Number.isInteger(this.nodeSequence) && this.nodeSequence >= 0)
        },
        checkBtnUpdate() {
            return this.nodeSequence < 0 || this.nodeName == '' || !this.nodeWrap;
        },
    },
    watch: {},
}
</script>

<style scoped></style>
